
// Actions
const PREFIX = 'calculus/materialstandards/';

export const SET_MATERIALSTANDARDS  = PREFIX + 'SET_MATERIALSTANDARDS';
export const MATERIAL_STANDARDS  = PREFIX + 'MATERIAL_STANDARDS';

import {
  ADD,
  PATCH,
  REMOVE,
} from './settings';

const INITIAL_STATE = {
  loading: true,
  data: []
};

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_MATERIALSTANDARDS:
      return {
        ...state,
        data: payload,
        loading: false
      };
      case ADD:
        if(payload.type != MATERIAL_STANDARDS) {
          return state;
        }
        return {
          ...state,
          data: [
            ...state.data,
            payload.item
          ]
        };

      case PATCH:
        if(payload.type != MATERIAL_STANDARDS) {
          return state;
        }
        return {
          ...state,
          data: state.data.map( item => {
            if(item.Nid === payload.item.Nid) {
              return payload.item;
            }
            return item;
          })
        };

      case REMOVE:
        if(payload.type != MATERIAL_STANDARDS) {
          return state;
        }

        const index = state.data.findIndex( (item) => {
          if(item.Nid === payload.id) {
            return true;
          }
        });

        return {
          ...state,
          data: [
            ...state.data.slice(0, index),
            ...state.data.slice(index + 1)
          ]
        };
    default:
      return state;
  }
}

// Action Creators
export function setMaterialStandards(payload) {
  return {
    type: SET_MATERIALSTANDARDS,
    payload: payload
  };
}
